import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static get targets() {
    return ['category', 'kimono', 'dress', 'grade', 'luxuryBrand']
  }

  connect() {
    const selectedCategory = this.categoryTarget.value
    this.toggle(selectedCategory)
    if (this.hasGradeTarget) {
      this.toggleLuxury(this.gradeTarget.value)
    }
  }

  change(event) {
    this.toggle(event.currentTarget.value)
    if (this.hasGradeTarget) {
      this.toggleLuxury(this.gradeTarget.value)
    }
  }

  onGradeChange(event) {
    this.toggleLuxury(event.currentTarget.value)
  }

  toggle(category) {
    if (!category) return
    if (category === 'dress') {
      this.kimonoTarget.style.display = 'none'
      this.dressTarget.style.display = ''
    } else {
      this.kimonoTarget.style.display = ''
      this.dressTarget.style.display = 'none'
    }
  }

  toggleLuxury(gradeId) {
    if (!this.hasLuxuryBrandTarget) return
    const isFiveStar = parseInt(gradeId, 10) === 5
    const isDress = this.categoryTarget && this.categoryTarget.value === 'dress'
    this.luxuryBrandTarget.style.display = isDress && isFiveStar ? '' : 'none'
  }
}
